import { defineMessages } from 'react-intl';

export const checkoutMessages = defineMessages({
  checkoutAddPopinSuccess: {
    id: 'checkout.addPopin.success',
    defaultMessage: 'Added to shopping bag',
  },
  noGiftSelected: {
    id: `checkout.noGiftSelected`,
    defaultMessage: `Please select your preferred gift, or choose 'I don't need a gift' if you prefer not to receive one.`,
  },
  gwpCheckoutCheckboxMessagePart1: {
    defaultMessage: `I would like to`,
    id: 'checkout.gwp.checkbox.message.part1',
  },
  gwpCheckoutCheckboxMessagePart2: {
    defaultMessage: `Create my account`,
    id: 'checkout.gwp.checkbox.message.part2',
  },
  gwpCheckoutCheckboxMessagePart3: {
    defaultMessage: `and`,
    id: 'checkout.gwp.checkbox.message.part3',
  },
  gwpCheckoutCheckboxMessagePart4: {
    defaultMessage: `Register my watch`,
    id: 'checkout.gwp.checkbox.message.part4',
  },
  gwpCheckoutTitle: {
    defaultMessage: `Gift with Purchase`,
    id: 'checkout.gwp.title',
  },
  gwpCheckoutPrompt: {
    defaultMessage: `As a special thank you for purchasing online, you'll receive a complimentary Breitling gift.`,
    id: 'checkout.gwp.prompt',
  },
  noNeedGift: {
    id: 'checkoutGwpNoNeedGift',
    defaultMessage: 'I dont need a gift',
  },
  breitlingClub: {
    id: 'breitling.club',
    defaultMessage: 'Breitling Club',
  },
  nflMarketingConsentTitle: {
    id: 'checkout.nflMarketingConsentTitle',
    defaultMessage: 'Affiliates communication',
  },
  nflMarketingConsentMessage: {
    id: 'checkout.nflMarketingConsentMessage',
    defaultMessage:
      'I consent to receive marketing communications from the Breitling External Affiliated Companies related to my purchase. For further information please refer to our {policyLink}.',
  },
  nflMarketingConsentPolicy: {
    id: 'checkout.nflMarketingConsentPolicy',
    defaultMessage: 'Website Privacy Policy',
  },
});
